import {
  CoinTransaction,
  CoinTransactionType,
  JoonUIColor,
  Typography,
} from "@joonapp/web-shared"
import dayjs from "dayjs"
import { useTranslation } from "react-i18next"

const TransactionTable = ({
  transactions,
}: {
  transactions: CoinTransaction[]
}) => {
  const { t } = useTranslation()
  return (
    <table
      style={{
        display: "block",
        maxHeight: "60vh",
        minHeight: "400px",
        overflowY: "auto",
        width: "100%",
        tableLayout: "fixed",
        borderCollapse: "separate",
        borderSpacing: "4px 0",
      }}
    >
      <thead>
        <tr>
          <td style={{ minWidth: "50px" }}>
            <Typography variant="bodySmallBold">{t("QL_DATE")}</Typography>
          </td>
          <td style={{ width: "100%", maxWidth: "50vw !important" }}>
            <Typography variant="bodySmallBold">
              {t("CT_TABLE_DESCRIPTION")}
            </Typography>
          </td>
          <td style={{ minWidth: "60px" }}>
            <Typography variant="bodySmallBold">
              {t("CT_TABLE_AMOUNT")}
            </Typography>
          </td>
          <td style={{ minWidth: "60px" }}>
            <Typography variant="bodySmallBold">
              {t("CT_TABLE_BALANCE")}
            </Typography>
          </td>
        </tr>
      </thead>

      <tbody>
        {transactions?.map((transaction) => (
          <CoinTransactionRow key={transaction.id} transaction={transaction} />
        ))}
      </tbody>
    </table>
  )
}

const CoinTransactionRow = ({
  transaction,
}: {
  transaction: CoinTransaction
}) => {
  const amountColor =
    transaction.amount > 0
      ? JoonUIColor.semantic.success
      : JoonUIColor.semantic.destructive
  const isCoinDeduction =
    transaction.type === CoinTransactionType.BONUS_REWARD_DEDUCTION
  return (
    <tr style={{ width: "100%" }} key={transaction.id}>
      <td>
        <Typography variant="bodySmall">
          {dayjs(transaction.date_created).format("MMM D")}
        </Typography>
      </td>
      <td style={{ maxWidth: "40vw" }}>
        <Typography
          variant="bodySmall"
          style={{ whiteSpace: "normal", wordWrap: "break-word" }}
          color={
            isCoinDeduction
              ? JoonUIColor.semantic.destructive
              : JoonUIColor.text.primary
          }
        >
          {transaction.display_string}
        </Typography>
      </td>
      <td>
        <Typography variant="bodySmall" color={amountColor}>
          {transaction.amount > 0 && "+"}
          {transaction.amount.toLocaleString()}
        </Typography>
      </td>
      <td>
        <Typography variant="bodySmall">
          {transaction.ending_balance.toLocaleString()}
        </Typography>
      </td>
    </tr>
  )
}

export default TransactionTable
